export const chainesLocales = {
    'Bienvenue': {
        'FR': {
            'title': 'Bienvenue dans le questionnaire de',
            'altLogo': 'Logo de l\'enquête',
            'button': 'Commencer'/*,
            'tls': 'À compter du 2 mars 2020, seules les versions de navigateur qui se chargent de la sécurité de la couche de transport (TLS) 1.2 et plus seront supportées à l’Institut de la statistique du Québec.<br><br><a href="https://www.stat.gouv.qc.ca/ssl-tls-information.html" target="_blank" rel="noopener noreferrer" class="text-info">Cliquez ici pour plus d’informations</a>'*/
        },
        'AN': {
            'title': 'Welcome to the questionnaire of the',
            'altLogo': 'Survey logo',
            'button': 'Start'/*,
            'tls': 'As of March 2, 2020, only browser versions that can manage Transport Layer Security (TLS) 1.2 or more will be supported at the Institut de la statistique du Québec.<br><br><a href="https://www.stat.gouv.qc.ca/ssl-tls-information_an.html " target="_blank" rel="noopener noreferrer" class="text-info">Click here for more information</a>'*/
        },
        'CR': {
            'title': 'ᐌᓪᒍᒣ ᑐ ᕞ qᐅᐁᔅᑎᐅᓐᓇᐃᕃ ᐅᕝ ᕞ',
            'altLogo': 'ᓱᕐᕓᔾ ᓗᑯ',
            'button': 'ᔅᑕᕐᑦ'
        },
        'CS': {
            'title': 'SYLLABIQUE ᐌᓪᒍᒣ ᑐ ᕞ qᐅᐁᔅᑎᐅᓐᓇᐃᕃ ᐅᕝ ᕞ',
            'altLogo': 'ᓱᕐᕓᔾ ᓗᑯ',
            'button': 'ᔅᑕᕐᑦ'
        }
    },
    'Consignes': {
        'FR': {
            'title': 'Consignes pour remplir le questionnaire',
            'titleNoQuest': 'Consignes',
            'button': 'J\'ai compris'
        },
        'AN': {
            'title': 'Instructions for filling out the questionnaire',
            'titleNoQuest': 'Instructions',
            'button': 'I understand'
        },
        'CR': {
            'title': 'ᐃᓐᔅᑦᕈᒡᑎᐅᓐᔅ ᕗᕐ ᕕᓪᓕᓐᒃ ᐆᑦ ᕞ qᐅᐁᔅᑎᐅᓐᓇᐃᕃ',
            'titleNoQuest': 'ᐃᓐᔅᑦᕈᒡᑎᐅᓐᔅ',
            'button': 'ᐃ ᐅᓐᑌᕐᔅᑕᓐᑦ'
        },
        'CS': {
            'title': 'ᐃᓐᔅᑦᕈᒡᑎᐅᓐᔅ ᕗᕐ ᕕᓪᓕᓐᒃ ᐆᑦ ᕞ qᐅᐁᔅᑎᐅᓐᓇᐃᕃ',
            'titleNoQuest': 'ᐃᓐᔅᑦᕈᒡᑎᐅᓐᔅ',
            'button': 'ᐃ ᐅᓐᑌᕐᔅᑕᓐᑦ'
        }    
    }, 
    'CreerMotPasse': {
        'FR': {
            'title': 'Créez un mot de passe',
            'labelPwd': 'Mot de passe',
            'invalidMsgPwd': 'Assurez-vous que le mot de passe répond aux critères.',
            'labelConfirm': 'Confirmation du mot de passe',
            'invalidMsgConfirm': 'Le mot de passe et sa confirmation doivent être identiques.',
            'button': 'Valider',
            'critTitle': 'Le mot de passe doit comprendre :',
            'crit1': 'au moins huit caractères',
            'crit2': 'au moins une lettre majuscule',
            'crit3': 'au moins une lettre minuscule',
            'crit4': 'au moins un chiffre',
            'invalidMsgCrit': 'Vérifiez que les critères de création d\'un mot de passe ont été respectés.'
        },
        'AN': {
            'title': 'Create a password',
            'labelPwd': 'Password',
            'invalidMsgPwd': 'Make sure your password meets the requirements.',
            'labelConfirm': 'Confirm your password',
            'invalidMsgConfirm': 'Your password and password confirmation must be identical.',
            'button': 'Validate',
            'critTitle': 'Your password must include:',
            'crit1': 'at least eight characters',
            'crit2': 'at least one upper-case letter',
            'crit3': 'at least one lower-case letter',
            'crit4': 'at least one number',
            'invalidMsgCrit': 'Please check that the password meets the requirements.'
        },
        'CR': {
            'title': 'ᒡᕃᐊᑌ ᐊ ᐸᔅᓼᕐᑦ',
            'labelPwd': 'ᐸᔅᓼᕐᑦ',
            'invalidMsgPwd': 'ᒪᑫ ᓱᕃ ᔫᕐ ᐸᔅᓼᕐᑦ ᒣᐁᑦᔅ ᕞ ᕃqᐅᐃᕃᒣᓐᑦᔅ,',
            'labelConfirm': 'ᒍᓐᕕᕐᒻ ᔫᕐ ᐸᔅᓼᕐᑦ',
            'invalidMsgConfirm': 'ᔫᕐ ᐸᔅᓼᕐᑦ ᐊᓐᑦ ᐸᔅᓼᕐᑦ ᒍᓐᕕᕐᒪᑎᐅᓐ ᒧᔅᑦ ᐯ ᐃᑌᓐᑎᒐᓪ᙮',
            'button': 'Vᐊᓕᑕᑌ',
            'critTitle': 'ᔫᕐ ᐸᔅᓼᕐᑦ ᒧᔅᑦ ᐃᓐᒡᓗᑌ:',
            'crit1': 'ᐊᑦ ᓓᐊᔅᑦ 8 ᒐᕋᒡᑌᕐᔅ',
            'crit2': '',
            'crit3': 'ᐊᑦ ᓓᐊᔅᑦ ᐅᓀ ᐅᑉᐯᕐ-ᒐᓭ ᓓᑦᑌᕐ',
            'crit4': 'ᐊᑦ ᓓᐊᔅᑦ ᐅᓀ ᓄᒻᐯᕐ',
            'invalidMsgCrit': 'ᑉᓓᐊᓭ ᒉᒡᒃ ᕦᑦ ᕞ ᐸᔅᓼᕐᑦ ᒣᐁᑦᔅ ᕞ ᕃqᐅᐃᕃᒣᓐᑦᔅ᙮'
        },
        'CS': {
            'title': 'ᒡᕃᐊᑌ ᐊ ᐸᔅᓼᕐᑦ',
            'labelPwd': 'ᐸᔅᓼᕐᑦ',
            'invalidMsgPwd': 'ᒪᑫ ᓱᕃ ᔫᕐ ᐸᔅᓼᕐᑦ ᒣᐁᑦᔅ ᕞ ᕃqᐅᐃᕃᒣᓐᑦᔅ,',
            'labelConfirm': 'ᒍᓐᕕᕐᒻ ᔫᕐ ᐸᔅᓼᕐᑦ',
            'invalidMsgConfirm': 'ᔫᕐ ᐸᔅᓼᕐᑦ ᐊᓐᑦ ᐸᔅᓼᕐᑦ ᒍᓐᕕᕐᒪᑎᐅᓐ ᒧᔅᑦ ᐯ ᐃᑌᓐᑎᒐᓪ᙮',
            'button': 'Vᐊᓕᑕᑌ',
            'critTitle': 'ᔫᕐ ᐸᔅᓼᕐᑦ ᒧᔅᑦ ᐃᓐᒡᓗᑌ:',
            'crit1': 'ᐊᑦ ᓓᐊᔅᑦ 8 ᒐᕋᒡᑌᕐᔅ',
            'crit2': '',
            'crit3': 'ᐊᑦ ᓓᐊᔅᑦ ᐅᓀ ᐅᑉᐯᕐ-ᒐᓭ ᓓᑦᑌᕐ',
            'crit4': 'ᐊᑦ ᓓᐊᔅᑦ ᐅᓀ ᓄᒻᐯᕐ',
            'invalidMsgCrit': 'ᑉᓓᐊᓭ ᒉᒡᒃ ᕦᑦ ᕞ ᐸᔅᓼᕐᑦ ᒣᐁᑦᔅ ᕞ ᕃqᐅᐃᕃᒣᓐᑦᔅ᙮'
        }
    },
    'CreerCourriel': {
        'FR': {
            'title': 'Lier une adresse courriel',
            'button': 'Valider',
            'labelCourriel': 'Adresse courriel',
            'labelQuestion': 'Souhaitez-vous lier une adresse courriel à votre identifant?',
            'non': 'Non',
            'oui': 'Oui',
            'erreurCourriel': 'Le format du courriel n\'est pas valide'
        },
        'AN': {
            'title': 'Link an email address',
            'button': 'Validate',
            'labelCourriel': 'Email address',
            'labelQuestion': 'Would you like to link an email address to your access code?',
            'non': 'No',
            'oui': 'Yes',
            'erreurCourriel': 'The email format is not respected'
        },
        'CR': {
            'title': 'ᓕᓐᒃ ᐊᓐ ᐁᒪᐃᓪ ᐊᑦᑦᕃᔅᔅ',
            'button': 'Vᐊᓕᑕᑌ',
            'labelCourriel': 'ᐁᒪᐃᓪ ᐊᑦᑦᕃᔅᔅ',
            'labelQuestion': 'ᐔᓪᑦ ᔫ ᓕᑫ ᑐ ᓕᓐᒃ ᐊᓐ ᐁᒪᐃᓪ ᐊᑦᑦᕃᔅᔅ ᑐ ᔫᕐ ᐊᒡᒉᔅᔅ ᒍᑌ?',
            'non': 'ᓄ',
            'oui': 'ᔦᔅ',
            'erreurCourriel': 'ᕞ ᐁᒪᐃᓪ ᕗᕐᒪᑦ ᐃᔅ ᓄᑦ ᕃᔅᐯᒡᑌᑦ'
        },
        'CS': {
            'title': 'ᓕᓐᒃ ᐊᓐ ᐁᒪᐃᓪ ᐊᑦᑦᕃᔅᔅ',
            'button': 'Vᐊᓕᑕᑌ',
            'labelCourriel': 'ᐁᒪᐃᓪ ᐊᑦᑦᕃᔅᔅ',
            'labelQuestion': 'ᐔᓪᑦ ᔫ ᓕᑫ ᑐ ᓕᓐᒃ ᐊᓐ ᐁᒪᐃᓪ ᐊᑦᑦᕃᔅᔅ ᑐ ᔫᕐ ᐊᒡᒉᔅᔅ ᒍᑌ?',
            'non': 'ᓄ',
            'oui': 'ᔦᔅ',
            'erreurCourriel': 'ᕞ ᐁᒪᐃᓪ ᕗᕐᒪᑦ ᐃᔅ ᓄᑦ ᕃᔅᐯᒡᑌᑦ'
        }
    },
    'VerifCourriel': {
        'FR': {
            'title': 'Confirmer l\'adresse courriel',
            'button': 'Valider',
            'labelCourriel': 'Nouvelle adresse courriel à lier à l\'identifiant',
            'labelLink': 'Adresse courriel liée à l\'identifiant',
            'labelQuestion': 'L\'adresse courriel ci-dessus est-elle toujours valide?',
            'non': 'Non',
            'oui': 'Oui',
            'erreurCourriel': 'Le format du courriel n\'est pas valide'
        },
        'AN': {
            'title': 'Link an email address',
            'button': 'Validate',
            'labelCourriel': 'New email to link to the acess code',
            'labelLink': 'Email address linked to the acess code',
            'labelQuestion': 'Is the above email still valid?',
            'non': 'No',
            'oui': 'Yes',
            'erreurCourriel': 'The email format is not respected'
        },
        'CR': {
            'title': 'ᓕᓐᒃ ᐊᓐ ᐁᒪᐃᓪ ᐊᑦᑦᕃᔅᔅ',
            'button': 'Vᐊᓕᑕᑌ',
            'labelCourriel': 'ᓀᐧ ᐁᒪᐃᓪ ᑐ ᓕᓐᒃ ᑐ ᕞ ᐊᒡᒉᔅᔅ ᒍᑌ',
            'labelLink': 'ᐁᒪᐃᓪ ᐊᑦᑦᕃᔅᔅ ᓕᓐᑫᑦ ᑐ ᕞ ᐊᒡᒉᔅᔅ ᒍᑌ',
            'labelQuestion': 'ᐃᔅ ᕞ ᐊᐳᕓ ᐁᒪᐃᓪ ᔅᑎᓪᓪ ᕙᓕᑦ?',
            'non': 'ᓄ',
            'oui': 'ᔦᔅ',
            'erreurCourriel': 'ᕞ ᐁᒪᐃᓪ ᕗᕐᒪᑦ ᐃᔅ ᓄᑦ ᕃᔅᐯᒡᑌᑦ'
        },
        'CS': {
            'title': 'ᓕᓐᒃ ᐊᓐ ᐁᒪᐃᓪ ᐊᑦᑦᕃᔅᔅ',
            'button': 'Vᐊᓕᑕᑌ',
            'labelCourriel': 'ᓀᐧ ᐁᒪᐃᓪ ᑐ ᓕᓐᒃ ᑐ ᕞ ᐊᒡᒉᔅᔅ ᒍᑌ',
            'labelLink': 'ᐁᒪᐃᓪ ᐊᑦᑦᕃᔅᔅ ᓕᓐᑫᑦ ᑐ ᕞ ᐊᒡᒉᔅᔅ ᒍᑌ',
            'labelQuestion': 'ᐃᔅ ᕞ ᐊᐳᕓ ᐁᒪᐃᓪ ᔅᑎᓪᓪ ᕙᓕᑦ?',
            'non': 'ᓄ',
            'oui': 'ᔦᔅ',
            'erreurCourriel': 'ᕞ ᐁᒪᐃᓪ ᕗᕐᒪᑦ ᐃᔅ ᓄᑦ ᕃᔅᐯᒡᑌᑦ'
        }
    },
    'SendRecoveryCode': {
        'FR': {
            'title': 'Réinitialisation du mot de passe',
            'button': 'Envoyer le code',
            'retourButton': 'Retour'
        },
        'AN': {
            'title': 'Reset password',
            'button': 'Send code',
            'retourButton': 'Return'
        },
        'CR': {
            'title': 'ᕃᓭᑦ ᐸᔅᓼᕐᑦ',
            'button': 'ᓭᓐᑦ ᒍᑌ',
            'retourButton': 'ᕃᑐᕐᓐ'
        },
        'CS': {
            'title': 'ᕃᓭᑦ ᐸᔅᓼᕐᑦ',
            'button': 'ᓭᓐᑦ ᒍᑌ',
            'retourButton': 'ᕃᑐᕐᓐ'
        }
    },
    'VerifRecoveryCode': {
        'FR': {
            'title': 'Réinitialisation du mot de passe',
            'button': 'Réinitialiser',
            'retourButton': 'Retour',
            'labelCode': 'Code de réinitialisation',
            'msgPreEmail': 'Un code de réinitialisation a été envoyé à l’adresse courriel suivante :',
            'msgPostEmail': 'Le code est valide pendant 30 minutes. Si vous ne recevez pas le courriel de confirmation ou si vous n’avez plus accès à cette adresse courriel, communiquez avec nous en cliquant sur le lien \"Nous joindre\" ci-dessous pour réinitialiser votre mot de passe.'
        },
        'AN': {
            'title': 'Reset password',
            'button': 'Reset',
            'retourButton': 'Return',
            'labelCode': 'Reset code',
            'msgPreEmail': 'A reset code has been sent to the following e-mail address:',
            'msgPostEmail': 'This code is valid for 30 minutes. If you do not receive the confirmation e-mail or if you no longer have access to this e-mail address, please contact Statistique Québec by clicking on \"Contact us\" below to reset your password.'
        },
        'CR': {
            'title': 'ᕃᓭᑦ ᐸᔅᓼᕐᑦ',
            'button': 'ᕃᓭᑦ',
            'retourButton': 'ᕃᑐᕐᓐ',
            'labelCode': 'ᕃᓭᑦ ᒍᑌ',
            'msgPreEmail': 'ᐊ ᕃᓭᑦ ᒍᑌ ᐦᐊᔅ ᐯᐁᓐ ᓭᓐᑦ ᑐ ᕞ ᕗᓪᓗᐎᓐᒃ ᐁ-ᒪᐃᓪ ᐊᑦᑦᕃᔅᔅ:',
            'msgPostEmail': 'ᕠᔅ ᒍᑌ ᐃᔅ ᕙᓕᑦ ᕗᕐ 30 ᒥᓄᑌᔅ᙮ ᐃᕝ ᔫ ᑐ ᓄᑦ ᕃᒉᐃᕓ ᕞ ᒍᓐᕕᕐᒪᑎᐅᓐ ᐁ-ᒪᐃᓪ ᐅᕐ ᐃᕝ ᔫ ᓄ ᓗᓐᑫᕐ ᐦᐊᕓ ᐊᒡᒉᔅᔅ ᑐ ᕠᔅ ᐁ-ᒪᐃᓪ ᐊᑦᑦᕃᔅᔅ, ᑉᓓᐊᓭ ᒍᓐᑕᒡᑦ Statistique Québec ᑉᔾ ᒡᓕᒡᑭᓐᒃ ᐅᓐ \"ᒍᓐᑕᒡᑦ ᐅᔅ\" ᐯᓗᐧ ᑐ ᕃᓭᑦ ᔫᕐ ᐸᔅᓼᕐᑦ᙮'
        },
        'CS': {
            'title': 'ᕃᓭᑦ ᐸᔅᓼᕐᑦ',
            'button': 'ᕃᓭᑦ',
            'retourButton': 'ᕃᑐᕐᓐ',
            'labelCode': 'ᕃᓭᑦ ᒍᑌ',
            'msgPreEmail': 'ᐊ ᕃᓭᑦ ᒍᑌ ᐦᐊᔅ ᐯᐁᓐ ᓭᓐᑦ ᑐ ᕞ ᕗᓪᓗᐎᓐᒃ ᐁ-ᒪᐃᓪ ᐊᑦᑦᕃᔅᔅ:',
            'msgPostEmail': 'ᕠᔅ ᒍᑌ ᐃᔅ ᕙᓕᑦ ᕗᕐ 30 ᒥᓄᑌᔅ᙮ ᐃᕝ ᔫ ᑐ ᓄᑦ ᕃᒉᐃᕓ ᕞ ᒍᓐᕕᕐᒪᑎᐅᓐ ᐁ-ᒪᐃᓪ ᐅᕐ ᐃᕝ ᔫ ᓄ ᓗᓐᑫᕐ ᐦᐊᕓ ᐊᒡᒉᔅᔅ ᑐ ᕠᔅ ᐁ-ᒪᐃᓪ ᐊᑦᑦᕃᔅᔅ, ᑉᓓᐊᓭ ᒍᓐᑕᒡᑦ Statistique Québec ᑉᔾ ᒡᓕᒡᑭᓐᒃ ᐅᓐ \"ᒍᓐᑕᒡᑦ ᐅᔅ\" ᐯᓗᐧ ᑐ ᕃᓭᑦ ᔫᕐ ᐸᔅᓼᕐᑦ᙮'
        }
    },
    'ConfirmRecoveryCode': {
        'FR': {
            'title': 'Réinitialisation du mot de passe',
            'button': 'Continuer',
            'msgPreEmail': 'Un mot de passe temporaire a été envoyé à l’adresse courriel suivante :',
            'msgPostEmail': 'Si vous ne recevez pas le courriel, communiquez avec nous en cliquant sur le lien \"Nous joindre\" ci-dessous pour obtenir le mot de passe.'
        },
        'AN': {
            'title': 'Reset password',
            'button': 'Continue',
            'msgPreEmail': 'A temporary password has been sent to the following e-mail address:',
            'msgPostEmail': 'If you do not receive the e-mail, please contact Statistique Québec by clicking on \"Contact us\" below to obtain your password.'
        },
        'CR': {
            'title': 'ᕃᓭᑦ ᐸᔅᓼᕐᑦ',
            'button': 'ᒍᓐᑎᓄᐁ',
            'msgPreEmail': 'ᐊ ᑌᒻᐳᕋᕐᔾ ᐸᔅᓼᕐᑦ ᐦᐊᔅ ᐯᐁᓐ ᓭᓐᑦ ᑐ ᕞ ᕗᓪᓗᐎᓐᒃ ᐁ-ᒪᐃᓪ ᐊᑦᑦᕃᔅᔅ:',
            'msgPostEmail': 'ᐃᕝ ᔫ ᑐ ᓄᑦ ᕃᒉᐃᕓ ᕞ ᐁ-ᒪᐃᓪ, ᑉᓓᐊᓭ ᒍᓐᑕᒡᑦ Statistique Québec ᑉᔾ ᒡᓕᒡᑭᓐᒃ ᐅᓐ \"ᒍᓐᑕᒡᑦ ᐅᔅ\" ᐯᓗᐧ ᑐ ᐅᑉᑕᐃᓐ ᔫᕐ ᐸᔅᓼᕐᑦ᙮'
        },
        'CS': {
            'title': 'ᕃᓭᑦ ᐸᔅᓼᕐᑦ',
            'button': 'ᒍᓐᑎᓄᐁ',
            'msgPreEmail': 'ᐊ ᑌᒻᐳᕋᕐᔾ ᐸᔅᓼᕐᑦ ᐦᐊᔅ ᐯᐁᓐ ᓭᓐᑦ ᑐ ᕞ ᕗᓪᓗᐎᓐᒃ ᐁ-ᒪᐃᓪ ᐊᑦᑦᕃᔅᔅ:',
            'msgPostEmail': 'ᐃᕝ ᔫ ᑐ ᓄᑦ ᕃᒉᐃᕓ ᕞ ᐁ-ᒪᐃᓪ, ᑉᓓᐊᓭ ᒍᓐᑕᒡᑦ Statistique Québec ᑉᔾ ᒡᓕᒡᑭᓐᒃ ᐅᓐ \"ᒍᓐᑕᒡᑦ ᐅᔅ\" ᐯᓗᐧ ᑐ ᐅᑉᑕᐃᓐ ᔫᕐ ᐸᔅᓼᕐᑦ᙮'
        }
    },
    'DemandeIdentifiant': {
        'FR': {
            'title': 'Entrez votre identifiant',
            /* DEPRECATED *//* 'text': 'Pour accéder au questionnaire de l’enquête, entrez votre identifiant de neuf caractères qui se trouve dans la lettre ou le courriel que vous avez reçu.',*/
            'labelIdent': 'Identifiant',
            'invalidMsgIdent': 'Identifiant non valide, vérifiez les caractères entrés.',
            'button': 'Valider'
        },
        'AN': {
            'title': 'Enter your identifier',
            /* DEPRECATED *//* 'text': 'To access the survey questionnaire, enter your 9-character identifier provided in the letter or e-mail you received.',*/
            'labelIdent': 'Identifier',
            'invalidMsgIdent': 'Invalid identifier. Please check the characters you entered.',
            'button': 'Validate'
        },
        'CR': {
            'title': 'ᐁᓐᑌᕐ ᔫᕐ ᐃᑌᓐᑎᕕᐁᕐ',
            /* DEPRECATED *//* 'text': 'To access the survey questionnaire, enter your 9-character identifier provided in the letter or e-mail you received.',*/
            'labelIdent': 'ᐃᑌᓐᑎᕕᐁᕐ',
            'invalidMsgIdent': 'ᐃᓐᕙᓕᑦ ᐃᑌᓐᑎᕕᐁᕐ᙮ ᑉᓓᐊᓭ ᒉᒡᒃ ᕞ ᒐᕋᒡᑌᕐᔅ ᔫ ᐁᓐᑌᕃᑦ᙮',
            'button': 'Vᐊᓕᑕᑌ'
        },
        'CS': {
            'title': 'ᐁᓐᑌᕐ ᔫᕐ ᐃᑌᓐᑎᕕᐁᕐ',
            /* DEPRECATED *//* 'text': 'To access the survey questionnaire, enter your 9-character identifier provided in the letter or e-mail you received.',*/
            'labelIdent': 'ᐃᑌᓐᑎᕕᐁᕐ',
            'invalidMsgIdent': 'ᐃᓐᕙᓕᑦ ᐃᑌᓐᑎᕕᐁᕐ᙮ ᑉᓓᐊᓭ ᒉᒡᒃ ᕞ ᒐᕋᒡᑌᕐᔅ ᔫ ᐁᓐᑌᕃᑦ᙮',
            'button': 'Vᐊᓕᑕᑌ'
        }
    },
    'DemandeMotPasse': {
        'FR': {
            'title': 'Entrez votre mot de passe',
            'textResetPwd': 'Vous devez communiquer avec nous en cliquant sur le lien \"Nous joindre\" ci-dessous pour réinitialiser votre mot de passe.',
            'labelPwd': 'Mot de passe',
            'labelResetPwd': 'Mot de passe oublié ?',
            'button': 'Valider'
        },
        'AN': {
            'title': 'Enter your password',
            'textResetPwd': 'Please contact Statistique Québec by clicking on \"Contact us\" below to reset your password.',
            'labelPwd': 'Password',
            'labelResetPwd': 'Forgot your password?',
            'button': 'Validate'
        },
        'CR': {
            'title': 'ᐁᓐᑌᕐ ᔫᕐ ᐸᔅᓼᕐᑦ',
            'textResetPwd': 'ᑉᓓᐊᓭ ᒍᓐᑕᒡᑦ Statistique Québec ᑉᔾ ᒡᓕᒡᑭᓐᒃ ᐅᓐ \"ᒍᓐᑕᒡᑦ ᐅᔅ\" ᐯᓗᐧ ᑐ ᕃᓭᑦ ᔫᕐ ᐸᔅᓼᕐᑦ᙮',
            'labelPwd': 'ᐸᔅᓼᕐᑦ',
            'labelResetPwd': 'ᕗᕐᑯᑦ ᔫᕐ ᐸᔅᓼᕐᑦ?',
            'button': 'Vᐊᓕᑕᑌ'
        },
        'CS': {
            'title': 'ᐁᓐᑌᕐ ᔫᕐ ᐸᔅᓼᕐᑦ',
            'textResetPwd': 'ᑉᓓᐊᓭ ᒍᓐᑕᒡᑦ Statistique Québec ᑉᔾ ᒡᓕᒡᑭᓐᒃ ᐅᓐ \"ᒍᓐᑕᒡᑦ ᐅᔅ\" ᐯᓗᐧ ᑐ ᕃᓭᑦ ᔫᕐ ᐸᔅᓼᕐᑦ᙮',
            'labelPwd': 'ᐸᔅᓼᕐᑦ',
            'labelResetPwd': 'ᕗᕐᑯᑦ ᔫᕐ ᐸᔅᓼᕐᑦ?',
            'button': 'Vᐊᓕᑕᑌ'
        }
    },
    'SessionTermine': {
        'FR': {
            'text': 'Votre session est expirée. Veuillez <a href="#" onclick="event.preventDefault(); window.location.reload();">cliquer ici</a> pour retourner au questionnaire.'
        },
        'AN': {
            'text': 'Your session has expired. Please <a href="#" onclick="event.preventDefault(); window.location.reload();">click here</a> to return to the questionnaire.'
        },
        'CR': {
            'text': 'ᔫᕐ ᓭᔅᓯᐅᓐ ᐦᐊᔅ ᐁ᙭ᐱᕃᑦ᙮ ᑉᓓᐊᓭ <a href="#" onclick="event.preventDefault(); window.location.reload();">ᒡᓕᒡᒃ ᐦᐁᕃ</a> ᑐ ᕃᑐᕐᓐ ᑐ ᕞ qᐅᐁᔅᑎᐅᓐᓇᐃᕃ᙮'
        },
        'CS': {
            'text': 'ᔫᕐ ᓭᔅᓯᐅᓐ ᐦᐊᔅ ᐁ᙭ᐱᕃᑦ᙮ ᑉᓓᐊᓭ <a href="#" onclick="event.preventDefault(); window.location.reload();">ᒡᓕᒡᒃ ᐦᐁᕃ</a> ᑐ ᕃᑐᕐᓐ ᑐ ᕞ qᐅᐁᔅᑎᐅᓐᓇᐃᕃ᙮'
        }
    },
    'ErreurSupport': {
        'FR': {
            'text': 'Le navigateur Microsoft Edge n\'est pas supporté. Veuillez utiliser Google Chrome, Mozilla Firefox, Safari ou Internet Explorer 11.'
        },
        'AN': {
            'text': 'Microsoft Edge is not supported. Please use one of Google Chrome, Mozilla Firefox, Safari or Internet Explorer 11.'
        },
        'CR': {
            'text': 'Microsoft Edge ᐃᔅ ᓄᑦ ᓱᑉᐳᕐᑌᑦ᙮ ᑉᓓᐊᓭ ᐅᓭ ᐅᓀ ᐅᕝ Google Chrome, Mozilla Firefox, Safari or Internet Explorer 11.'
        },
        'CS': {
            'text': 'Microsoft Edge ᐃᔅ ᓄᑦ ᓱᑉᐳᕐᑌᑦ᙮ ᑉᓓᐊᓭ ᐅᓭ ᐅᓀ ᐅᕝ Google Chrome, Mozilla Firefox, Safari or Internet Explorer 11.'
        }
    },
    'QuitteQuestionnaire': {
        'FR': {
            'defaut': 'Merci de votre participation.',
            'complete': 'Votre questionnaire a été transmis avec succès. Merci de votre participation.',
            'elimine': 'Nous avons détecté une incohérence dans l’identification du dossier. Nous vous contacterons pour vérifier vos renseignements. Merci.',
            'interrompu': 'Vous pouvez revenir inscrire vos réponses plus tard. Sinon, nous vous contacterons d’ici quelques jours pour les recueillir. Merci de votre participation.',
            'quota': 'Vous n’êtes malheureusement pas admissible. Merci de votre collaboration.',
            'inactif': 'Ce questionnaire est présentement inaccessible. Nous vous invitons à revenir plus tard. Merci de votre collaboration.',
            'reacces': 'Le questionnaire est terminé. Vous ne pouvez pas y accéder. Veuillez communiquer avec nous au besoin. Merci.'
        },
        'AN': {
            'defaut': 'Thank you for your participation.',
            'complete': 'Your questionnaire has been successfully submitted. Thank you for your participation.',
            'elimine': 'We detected an inconsistency in the identification of your file. We will contact you to verify your information. Thank you.',
            'interrompu': 'You can come back to enter your answers later. Otherwise, we will contact you within the next few days to collect them. Thank you for your participation.',
            'quota': 'Unfortunately, you are not eligible. Thank you for your cooperation.',
            'inactif': 'This questionnaire is currently unavailable. Please come back later. Thank you for your cooperation.',
            'reacces': 'This questionnaire has been completed. You cannot access it. Please contact us if necessary. Thank you.'
        },
        'CR': {
            'defaut': 'ᕦᓐᒃ ᔫ ᕗᕐ ᔫᕐ ᐸᕐᑎᒋᐸᑎᐅᓐ᙮',
            'complete': 'Your questionnaire has been successfully submitted. Thank you for your participation.',
            'elimine': 'We detected an inconsistency in the identification of your file. We will contact you to verify your information. Thank you.',
            'interrompu': 'You can come back to enter your answers later. Otherwise, we will contact you within the next few days to collect them. Thank you for your participation.',
            'quota': 'Unfortunately, you are not eligible. Thank you for your cooperation.',
            'inactif': 'This questionnaire is currently unavailable. Please come back later. Thank you for your cooperation.',
            'reacces': 'This questionnaire has been completed. You cannot access it. Please contact us if necessary. Thank you.'
        },
        'CS': {
            'defaut': 'ᕦᓐᒃ ᔫ ᕗᕐ ᔫᕐ ᐸᕐᑎᒋᐸᑎᐅᓐ᙮',
            'complete': 'Your questionnaire has been successfully submitted. Thank you for your participation.',
            'elimine': 'We detected an inconsistency in the identification of your file. We will contact you to verify your information. Thank you.',
            'interrompu': 'You can come back to enter your answers later. Otherwise, we will contact you within the next few days to collect them. Thank you for your participation.',
            'quota': 'Unfortunately, you are not eligible. Thank you for your cooperation.',
            'inactif': 'This questionnaire is currently unavailable. Please come back later. Thank you for your cooperation.',
            'reacces': 'This questionnaire has been completed. You cannot access it. Please contact us if necessary. Thank you.'
        }
    },
    'Erreur404': {
        'FR': {
            /*'text': 'Enquête inexistante. Assurez-vous d\'avoir le bon lien pour y accéder.',*/
            'text': 'Une erreur est survenue lors de l\'ouverture du questionnaire. Assurez-vous d\'avoir le bon lien et réessayer.',
        },
        'AN': {
            /*'text': 'Non-existing survey. Make sure you have the correct link to the survey.',*/
            'text': 'An error occurred while opening the questionnaire. Please make sure you have the correct link and try again.',
        },
        'CR': {
            /*'text': 'Non-existing survey. Make sure you have the correct link to the survey.',*/
            'text': 'CREE An error occurred while opening the questionnaire. Please make sure you have the correct link and try again.',
        },
        'CS': {
            /*'text': 'Non-existing survey. Make sure you have the correct link to the survey.',*/
            'text': 'CREE An error occurred while opening the questionnaire. Please make sure you have the correct link and try again.',
        }
    },
    'Questionnaire': {
        'FR': {
            'iframeTitle': 'Questionnaire',
        },
        'AN': {
            'iframeTitle': 'Questionnaire',
        },
        'CR': {
            'iframeTitle': 'Qᐅᐁᔅᑎᐅᓐᓇᐃᕃ',
        },
        'CS': {
            'iframeTitle': 'Qᐅᐁᔅᑎᐅᓐᓇᐃᕃ',
        }
    },
    'App': {
        'FR': {
            'loadingText': 'Chargement...'
        },
        'AN': {
            'loadingText': 'Loading...'
        },
        'CR': {
            'loadingText': 'ᓗᐊᑎᓐᒃ᙮᙮᙮'
        },
        'CS': {
            'loadingText': 'ᓗᐊᑎᓐᒃ᙮᙮᙮'
        }
    },
    'ConsignesModal': {
        'FR': {
            'title': 'Consignes pour remplir le questionnaire',
            'titleNoQuest': 'Consignes'
        },
        'AN': {
            'title': 'Instructions for filling out the questionnaire',
            'titleNoQuest': 'Instructions'
        },
        'CR': {
            'title': 'ᐃᓐᔅᑦᕈᒡᑎᐅᓐᔅ ᕗᕐ ᕕᓪᓕᓐᒃ ᐆᑦ ᕞ qᐅᐁᔅᑎᐅᓐᓇᐃᕃ',
            'titleNoQuest': 'ᐃᓐᔅᑦᕈᒡᑎᐅᓐᔅ'
        },
        'CS': {
            'title': 'ᐃᓐᔅᑦᕈᒡᑎᐅᓐᔅ ᕗᕐ ᕕᓪᓕᓐᒃ ᐆᑦ ᕞ qᐅᐁᔅᑎᐅᓐᓇᐃᕃ',
            'titleNoQuest': 'ᐃᓐᔅᑦᕈᒡᑎᐅᓐᔅ'
        }
    },
    'NousJoindreModal': {
        'FR': {
            'title': 'Nous joindre'
        },
        'AN': {
            'title': 'Contact us'
        },
        'CR': {
            'title': 'ᒍᓐᑕᒡᑦ ᐅᔅ'
        },
        'CS': {
            'title': 'ᒍᓐᑕᒡᑦ ᐅᔅ'
        }
    },
    'Footer': {
        'FR': {
            'textCopy': '© Gouvernement du Québec,',
            'altLogoQc': 'Gouvernement du Québec.',
            'urlGouvQc': 'https://www.quebec.ca/',
            'urlCopyright': 'https://www.quebec.ca/droit-auteur'
        },
        'AN': {
            'textCopy': '© Gouvernement du Québec,',
            'altLogoQc': 'Gouvernement du Québec.',
            'urlGouvQc': 'https://www.quebec.ca/en',
            'urlCopyright': 'https://www.quebec.ca/en/copyright'
        },
        'CR': {
            'textCopy': '© Gouvernement du Québec,',
            'altLogoQc': 'Gouvernement du Québec.',
            'urlGouvQc': 'https://www.quebec.ca/en',
            'urlCopyright': 'https://www.quebec.ca/en/copyright'
        },
        'CS': {
            'textCopy': '© Gouvernement du Québec,',
            'altLogoQc': 'Gouvernement du Québec.',
            'urlGouvQc': 'https://www.quebec.ca/en',
            'urlCopyright': 'https://www.quebec.ca/en/copyright'
        }
    },
    'InputPassword': {
        'FR': {
            'labelHidePwd': 'Cacher le mot de passe',
            'labelShowPwd': 'Révéler le mot de passe',
            'labelCapsLock': 'La touche de verrouillage des majuscules est active.',
            'invalidMsgPwd': 'Mot de passe non valide, vérifiez les caractères entrés.'
        },
        'AN': {
            'labelHidePwd': 'Hide password',
            'labelShowPwd': 'Show password',
            'labelCapsLock': 'The Caps Lock key is on.',
            'invalidMsgPwd': 'Invalid password. Please check the characters you entered.'
        },
        'CR': {
            'labelHidePwd': 'ᐦᐃᑌ ᐸᔅᓼᕐᑦ',
            'labelShowPwd': 'ᔓᐧ ᐸᔅᓼᕐᑦ',
            'labelCapsLock': 'ᕞ ᒐᑉᔅ ᓗᒡᒃ ᑫᔾ ᐃᔅ ᐅᓐ᙮',
            'invalidMsgPwd': 'ᐃᓐᕙᓕᑦ ᐸᔅᓼᕐᑦ᙮ ᑉᓓᐊᓭ ᒉᒡᒃ ᕞ ᒐᕋᒡᑌᕐᔅ ᔫ ᐁᓐᑌᕃᑦ᙮'
        },
        'CS': {
            'labelHidePwd': 'ᐦᐃᑌ ᐸᔅᓼᕐᑦ',
            'labelShowPwd': 'ᔓᐧ ᐸᔅᓼᕐᑦ',
            'labelCapsLock': 'ᕞ ᒐᑉᔅ ᓗᒡᒃ ᑫᔾ ᐃᔅ ᐅᓐ᙮',
            'invalidMsgPwd': 'ᐃᓐᕙᓕᑦ ᐸᔅᓼᕐᑦ᙮ ᑉᓓᐊᓭ ᒉᒡᒃ ᕞ ᒐᕋᒡᑌᕐᔅ ᔫ ᐁᓐᑌᕃᑦ᙮'
        }
    },
    'Page': {
        'FR': {
            'helpTextPreLink': 'Besoin d’aide pour remplir le questionnaire? Communiquez avec nous. Cliquez sur ',
            'helpTextPreLinkNoQuest': 'Besoin d’aide? Communiquez avec nous. Cliquez sur ',
            /*'helpTextPostLink': 'pour obtenir nos coordonnées.',*/
            'helpTextPostLink': '.',
            'helpTextPostLinkNoQuest': '.',
            'contactUslinkText': 'Nous&nbsp;joindre',
            'tls': 'À compter du 2 mars 2020, seules les versions de navigateur qui se chargent de la sécurité de la couche de transport (TLS) 1.2 et plus seront supportées à l’Institut.<br><a href="https://www.stat.gouv.qc.ca/ssl-tls-information.html" target="_blank" rel="noopener noreferrer" class="text-info">Cliquez ici pour plus d’informations</a>'
        },
        'AN': {
            'helpTextPreLink': 'Need help filling out the questionnaire? Get in touch with us. Click on ',
            'helpTextPreLinkNoQuest': 'Need help? Get in touch with us. Click on ',
            /*'helpTextPostLink': 'to obtain our contact information.',*/
            'helpTextPostLink': '.',
            'helpTextPostLinkNoQuest': '.',
            'contactUslinkText': 'Contact&nbsp;us',
            'tls': 'As of March 2, 2020, only browser versions that can manage Transport Layer Security (TLS) 1.2 or more will be supported at the Institut.<br><a href="https://www.stat.gouv.qc.ca/ssl-tls-information_an.html " target="_blank" rel="noopener noreferrer" class="text-info">Click here for more information</a>'
        },
        'CR': {
            'helpTextPreLink': 'ᓀᐁᑦ ᐦᐁᓪᑉ ᕕᓪᓕᓐᒃ ᐆᑦ ᕞ qᐅᐁᔅᑎᐅᓐᓇᐃᕃ? Gᐁᑦ ᐃᓐ ᑑᒡ ᐎᕪ ᐅᔅ᙮ ᒡᓕᒡᒃ ᐅᓐ',
            'helpTextPreLinkNoQuest': 'ᓀᐁᑦ ᐦᐁᓪᑉ? Gᐁᑦ ᐃᓐ ᑑᒡ ᐎᕪ ᐅᔅ᙮ ᒡᓕᒡᒃ ᐅᓐ',
            /*'helpTextPostLink': 'to obtain our contact information.',*/
            'helpTextPostLink': '.',
            'helpTextPostLinkNoQuest': '.',
            'contactUslinkText': 'ᒍᓐᑕᒡᑦ&nbsp;ᐅᔅ',
            'tls': 'As of March 2, 2020, only browser versions that can manage Transport Layer Security (TLS) 1.2 or more will be supported at the Institut.<br><a href="https://www.stat.gouv.qc.ca/ssl-tls-information_an.html " target="_blank" rel="noopener noreferrer" class="text-info">Click here for more information</a>'
        },
        'CS': {
            'helpTextPreLink': 'ᓀᐁᑦ ᐦᐁᓪᑉ ᕕᓪᓕᓐᒃ ᐆᑦ ᕞ qᐅᐁᔅᑎᐅᓐᓇᐃᕃ? Gᐁᑦ ᐃᓐ ᑑᒡ ᐎᕪ ᐅᔅ᙮ ᒡᓕᒡᒃ ᐅᓐ',
            'helpTextPreLinkNoQuest': 'ᓀᐁᑦ ᐦᐁᓪᑉ? Gᐁᑦ ᐃᓐ ᑑᒡ ᐎᕪ ᐅᔅ᙮ ᒡᓕᒡᒃ ᐅᓐ',
            /*'helpTextPostLink': 'to obtain our contact information.',*/
            'helpTextPostLink': '.',
            'helpTextPostLinkNoQuest': '.',
            'contactUslinkText': 'ᒍᓐᑕᒡᑦ&nbsp;ᐅᔅ',
            'tls': 'As of March 2, 2020, only browser versions that can manage Transport Layer Security (TLS) 1.2 or more will be supported at the Institut.<br><a href="https://www.stat.gouv.qc.ca/ssl-tls-information_an.html " target="_blank" rel="noopener noreferrer" class="text-info">Click here for more information</a>'
        }
    },
    'PIV': {
        'FR': {
            'altLogoIsq': 'Logo Institut de la statistique du Québec',
            'faqLinkText': 'FAQ',
            'faqLinkHref': 'https://statistique.quebec.ca/fr/enquetes/information-pour-les-participants#cb_foire-aux-questions-participants-aux-enquetes',
            'confLinkText': 'Confidentialité',
            'confLinkHref': 'https://statistique.quebec.ca/fr/enquetes/information-pour-les-participants/confidentialite-et-protection-des-renseignements-personnels',
            'consignesLinkText': 'Consignes',
            'quitLinkText': 'Quitter',
            'langLinkText': 'English',
            'guideLinkText': 'Guide',
            'definitionsLinkText': 'Définitions',
            'annexeLinkText': 'Annexe',
            'contactUslinkText': 'Nous&nbsp;joindre',
            'navbarTogglerLabel': 'Afficher le menu de l\'entête'
        },
        'AN': {
            'altLogoIsq': 'Institut de la statistique du Québec logo',
            'faqLinkText': 'FAQ',
            'faqLinkHref': 'https://statistique.quebec.ca/en/enquetes/information-for-participants#cb_foire-aux-questions-participants-aux-enquetes',
            'confLinkText': 'Confidentiality',
            'confLinkHref': 'https://statistique.quebec.ca/en/enquetes/information-for-participants/confidentiality-and-the-protection-of-personal-information',
            'consignesLinkText': 'Instructions',
            'quitLinkText': 'Exit',
            'langLinkText': 'Français',
            'guideLinkText': 'Guide',
            'definitionsLinkText': 'Definitions',
            'annexeLinkText': 'Appendix',
            'contactUslinkText': 'Contact&nbsp;us',
            'navbarTogglerLabel': 'Show header menu'
        },
        'CR': {
            'altLogoIsq': 'Institut de la statistique du Québec logo',
            'faqLinkText': 'ᕙQ',
            'faqLinkHref': 'https://statistique.quebec.ca/en/enquetes/information-for-participants#cb_foire-aux-questions-participants-aux-enquetes',
            'confLinkText': 'ᒍᓐᕕᑌᓐᑎᐊᓕᑦᔾ',
            'confLinkHref': 'https://statistique.quebec.ca/en/enquetes/information-for-participants/confidentiality-and-the-protection-of-personal-information',
            'consignesLinkText': 'ᐃᓐᔅᑦᕈᒡᑎᐅᓐᔅ',
            'quitLinkText': 'ᐁ᙭ᐃᑦ',
            'langLinkText': 'Français',
            'guideLinkText': 'Gᐅᐃᑌ',
            'definitionsLinkText': 'Dᐁᕕᓂᑎᐅᓐᔅ',
            'annexeLinkText': 'ᐊᑉᐯᓐᑎ᙭',
            'contactUslinkText': 'ᒍᓐᑕᒡᑦ&nbsp;ᐅᔅ',
            'navbarTogglerLabel': 'ᔓᐧ ᐦᐁᐊᑌᕐ ᒣᓄ'
        },
        'CS': {
            'altLogoIsq': 'Institut de la statistique du Québec logo',
            'faqLinkText': 'ᕙQ',
            'faqLinkHref': 'https://statistique.quebec.ca/en/enquetes/information-for-participants#cb_foire-aux-questions-participants-aux-enquetes',
            'confLinkText': 'ᒍᓐᕕᑌᓐᑎᐊᓕᑦᔾ',
            'confLinkHref': 'https://statistique.quebec.ca/en/enquetes/information-for-participants/confidentiality-and-the-protection-of-personal-information',
            'consignesLinkText': 'ᐃᓐᔅᑦᕈᒡᑎᐅᓐᔅ',
            'quitLinkText': 'ᐁ᙭ᐃᑦ',
            'langLinkText': 'Français',
            'guideLinkText': 'Gᐅᐃᑌ',
            'definitionsLinkText': 'Dᐁᕕᓂᑎᐅᓐᔅ',
            'annexeLinkText': 'ᐊᑉᐯᓐᑎ᙭',
            'contactUslinkText': 'ᒍᓐᑕᒡᑦ&nbsp;ᐅᔅ',
            'navbarTogglerLabel': 'ᔓᐧ ᐦᐁᐊᑌᕐ ᒣᓄ'
        }
    },
    'UserDisplay': {
        'FR': {
            'identText': 'Votre identifiant'
        },
        'AN': {
            'identText': 'Your identifier'
        },
        'CR': {
            'identText': 'ᔫᕐ ᐃᑌᓐᑎᕕᐁᕐ'
        },
        'CS': {
            'identText': 'ᔫᕐ ᐃᑌᓐᑎᕕᐁᕐ'
        }
    },
    'ErrApi': {
        'FR': {
            'msg': 'Problème lors de l\'identification, s\'il-vous-plaît veuillez réessayer ultérieurement.'
        },
        'AN': {
            'msg': 'A problem occurred during identification, please try again later.'
        },
        'CR': {
            'msg': 'ᐊ ᑉᕈᑉᓓᒻ ᐦᐊᔅ ᐅᒡᒍᕃᑦ ᑐᕆᓐᒃ ᐃᑌᓐᑎᕕᒐᑎᐅᓐ, ᑉᓓᐊᓭ ᑦᕐᔾ ᐊᑲᐃᓐ ᓚᑌᕐ᙮'
        },
        'CS': {
            'msg': 'ᐊ ᑉᕈᑉᓓᒻ ᐦᐊᔅ ᐅᒡᒍᕃᑦ ᑐᕆᓐᒃ ᐃᑌᓐᑎᕕᒐᑎᐅᓐ, ᑉᓓᐊᓭ ᑦᕐᔾ ᐊᑲᐃᓐ ᓚᑌᕐ᙮'
        }
    }
};